"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Modal = _interopRequireDefault(require("antd/lib/modal/Modal"));

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/zh-cn");

var _errorPage = _interopRequireDefault(require("./../../../../error-views/errorPage"));

var _RmName = _interopRequireDefault(require("../../../../../RmName.json"));

// import { useHistory } from 'react-router';
var Option = _antd.Select.Option;

var ValidForm = function ValidForm(_ref) {
  var visible = _ref.visible,
      onCancel = _ref.onCancel,
      request = _ref.request,
      item = _ref.item;

  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = (0, _slicedToArray2.default)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token"); // const history = useHistory();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      btn = _useState4[0],
      setBtn = _useState4[1];

  var _useState5 = (0, _react.useState)(visible),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 1),
      formVisible = _useState6[0];

  var initialFormValues = {
    motherName: item.Mother_name,
    dob: item.DOB,
    whatsappNo: item.WhatsApp_no,
    address: item.Address,
    subject: item.Subject,
    Student_name: item.Student_name,
    RM_code: item.RM_code,
    Joining_date: item.Joining_date,
    School_fee: item.School_fee,
    community: item.Local_address,
    comment: ''
  };
  (0, _react.useEffect)(function () {
    if (request === 'Approved') {
      setBtn('Valid');
    } else {
      setBtn("Invalid");
    }

    ;
    form.setFieldsValue(initialFormValues); // eslint-disable-next-line
  }, [item]);

  var MakeValid = function MakeValid() {
    var f1 = form.getFieldValue();
    var obj = {
      joiningDate: item.Joining_date,
      RMcode: item.RM_code,
      schoolFee: item.School_fee,
      name: item.Student_name,
      address: f1.address,
      CLcode: item.CL_code,
      callingNo: item.Calling_no,
      studentClass: item.Class,
      DOB: f1.dob,
      motherName: f1.motherName,
      whatsAppNo: f1.whatsappNo,
      comment: f1.comment,
      schoolType: item.school_type,
      mathWs: item.Worksheet_no,
      mathLabel: item.Label,
      englishWs: item.English_worksheet_no,
      englishLabel: item.English_label,
      MCB: item.MCB,
      subject: f1.subject,
      Student_name: f1.Student_name,
      RM_code: f1.RM_code,
      Joining_date: f1.Joining_date,
      School_fee: f1.School_fee,
      community: f1.community
    };

    if (btn === 'Invalid' && f1.comment === "") {
      alert("Please Select a reason");
    } else {
      var url = _config.default.actionOnNewEnrolledStudent + cl + "&request=" + request;

      _axios.default.post(url, obj, {
        headers: {
          'Authorization': token
        }
      }).then(function (response) {
        if (response.data.status === "error") setapiError(response.data);else {
          if (request === 'Approved') {
            alert("Student succesfully Approved");
            window.location = '/clPortal/app/parent/requests';
            onCancel();
          } else {
            alert("Student succesfully Rejected");
            window.location = '/clPortal/app/parent/requests';
            onCancel();
          }
        }
      }, function (error) {
        var obj = {
          "status": "error",
          "message": "Network Error"
        };
        if (error.response) setapiError(error.response);else setapiError(obj);
      });
    }
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : /*#__PURE__*/_react.default.createElement(_Modal.default, {
    title: "Edit Details : Check details and ".concat(btn, " request"),
    centered: true,
    visible: formVisible,
    onOk: MakeValid,
    onCancel: onCancel,
    cancelButtonProps: {
      style: {
        display: 'none'
      }
    },
    okText: btn === 'Invalid' ? "Invalid" : "Valid",
    okButtonProps: btn === 'Invalid' ? {
      style: {
        backgroundColor: 'red'
      }
    } : {
      style: {
        backgroundColor: 'green'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    form: form,
    onFinish: MakeValid
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Student_name",
    label: "Student Name"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "Student_name"
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "RM_code",
    label: _RmName.default.nameCode
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "RM_code"
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "motherName",
    label: "Mother Name"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "motherName"
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Joining_date",
    label: "Joining Date"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "Joining_date",
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Date of Birth"
  }, /*#__PURE__*/_react.default.createElement(_antd.DatePicker, {
    defaultValue: (0, _moment.default)("{".concat(item.DOB, "}"), 'YYYY-MM-DD'),
    format: "YYYY-MM-DD"
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Subject",
    name: "subject"
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    value: item.Subject
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "Math"
  }, "Math"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "English"
  }, "English"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Both"
  }, "Both"))), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "whatsappNo",
    label: "WhatsApp No."
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "whatsappNo"
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "School_fee",
    label: "School Fee"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "School_fee"
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "address",
    label: "Address"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "address"
  })), btn === 'Invalid' ? /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "comment",
    label: "Please Select a reason"
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, {
    className: "p-2 m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u092B\u0940\u0938 \u091C\u094D\u092F\u093E\u0926\u093E \u0939\u0948\u0964"
  }, "\u092B\u0940\u0938 \u091C\u094D\u092F\u093E\u0926\u093E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u090F\u0928\u0930\u094B\u0932 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0909\u092E\u094D\u0930 \u092C\u0921\u093C\u0940 \u0939\u0948\u0964"
  }, "\u090F\u0928\u0930\u094B\u0932 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0909\u092E\u094D\u0930 \u092C\u0921\u093C\u0940 \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u090F\u0928\u0930\u094B\u0932 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0909\u092E\u094D\u0930 \u091B\u094B\u091F\u0940 \u0939\u0948\u0964"
  }, "\u090F\u0928\u0930\u094B\u0932 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0909\u092E\u094D\u0930 \u091B\u094B\u091F\u0940 \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0938\u0939\u0940 \u0928\u0939\u0940\u0902 \u0939\u0948\u0964"
  }, " \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0938\u0939\u0940 \u0928\u0939\u0940\u0902 \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0938\u0902\u092A\u0930\u094D\u0915 \u0928\u0939\u0940\u0902 \u0939\u0941\u0906\u0964"
  }, "  \u0938\u0902\u092A\u0930\u094D\u0915 \u0928\u0939\u0940\u0902 \u0939\u0941\u0906\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0915\u094D\u0932\u093E\u0938 \u092C\u0939\u0941\u0924 \u091C\u094D\u092F\u093E\u0926\u093E \u0939\u0948\u0964"
  }, "\u0915\u094D\u0932\u093E\u0938 \u092C\u0939\u0941\u0924 \u091C\u094D\u092F\u093E\u0926\u093E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0909\u0938\u0915\u0947 \u092A\u093E\u0938 \u0938\u094D\u092E\u093E\u0930\u094D\u091F\u092B\u094B\u0928 \u0928\u0939\u0940\u0902 \u0939\u0948\u0964"
  }, "\u0909\u0938\u0915\u0947 \u092A\u093E\u0938 \u0938\u094D\u092E\u093E\u0930\u094D\u091F\u092B\u094B\u0928 \u0928\u0939\u0940\u0902 \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0909\u0938\u0915\u0947 \u092A\u093E\u0938 \u0935\u094D\u0939\u093E\u091F\u094D\u0938\u090F\u092A \u0928\u0939\u0940\u0902 \u0939\u0948\u0964"
  }, "\u0909\u0938\u0915\u0947 \u092A\u093E\u0938 \u0935\u094D\u0939\u093E\u091F\u094D\u0938\u090F\u092A \u0928\u0939\u0940\u0902 \u0939\u0948\u0964")))) : null));
};

var _default = ValidForm;
exports.default = _default;